/* unplugin-vue-components disabled */import { render } from "./DeviceSettings.vue?vue&type=template&id=380a1d30&ts=true"
import script from "./DeviceSettings.vue?vue&type=script&lang=ts"
export * from "./DeviceSettings.vue?vue&type=script&lang=ts"

import "./DeviceSettings.vue?vue&type=style&index=0&id=380a1d30&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__